import { render, staticRenderFns } from "./artefact-image.vue?vue&type=template&id=921b6cfe&scoped=true&"
import script from "./artefact-image.vue?vue&type=script&lang=ts&"
export * from "./artefact-image.vue?vue&type=script&lang=ts&"
import style0 from "./artefact-image.vue?vue&type=style&index=0&id=921b6cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921b6cfe",
  null
  
)

export default component.exports